
// abb 250823 myinvois
import { RecentDocumentsApiResponse, InvoiceItem, ClassificationCode, UnitType, TaxType, Seller } from './types';
import { api } from './../api';

export const fetchMyinvoisCredentials = async () => {

    const token = localStorage.getItem('token'); // Get the stored token

    try {
        const response = await api.get(
            `/myinvois/credentials`,
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Send the token in the Authorization header
                },
            }
        );

        // console.log('fetchMyinvoisCredentials:', response);

        localStorage.setItem('myinvois_credentials', JSON.stringify(response.data));

        return response.data;
    } catch (error) {
        console.error('Error fetchMyinvoisCredentials :', error);
        throw error;
    }
};

// Add this new function// This function now calls YOUR backend endpoint
export const authenticateMyinvois = async (): Promise<string> => {

    const token = localStorage.getItem('token'); // Get the stored token

    // No need to pass credentials from frontend anymore
    const endpoint = '/myinvois/authenticate'; // Your new backend endpoint

    try {
        // console.log(`Attempting to authenticate with Myinvois via backend endpoint: ${endpoint} with token ${token}`);
        // Use your existing 'api' instance to call your backend

        const response = await api.get(
            endpoint,
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Send the token in the Authorization header
                },
            }
        );

        // console.log('Backend Authentication Response:', response.data);

        // Extract the token - adjust 'accessToken' based on how your backend sends it
        const accessToken = response.data?.accessToken; // Or response.data?.token, etc.

        if (!accessToken) {
            console.error('Access token not found in response from backend:', response.data);
            throw new Error('Access token not received from backend.');
        }

        return accessToken;

    } catch (error: any) {
        console.error('Error authenticating via backend:', error.response?.data || error.message);
        const errorMessage = error.response?.data?.message || error.message || 'Unknown backend authentication error';
        throw new Error(`Myinvois authentication via backend failed: ${errorMessage}`);
    }
};


//
// Updated fetchMyinvoisDocs function
export const fetchMyinvoisDocs = async (invoiceTypeCode?: string | null) => { // Make invoiceTypeCode optional and accept string or null/undefined

    const token = localStorage.getItem('token'); // Get the stored token
    if (!token) {
        // It's often better to throw an error here or handle it consistently
        console.error('Error: No authentication token found for fetchMyinvoisDocs');
        throw new Error('Authentication required.');
    }

    // Construct the endpoint dynamically
    let endpoint = '/myinvois/document-types';
    if (invoiceTypeCode) { // Check if invoiceTypeCode has a truthy value (not null, undefined, empty string, 0)
        endpoint = `/myinvois/document-types/${encodeURIComponent(invoiceTypeCode)}`; // Append the code if provided
    }

    console.log(`Fetching Myinvois docs from endpoint: ${endpoint}`); // Log the final endpoint being used

    try {
        const response = await api.get(
            endpoint, // Use the dynamically constructed endpoint
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Send the token in the Authorization header
                },
                // No need for params if the code is part of the URL path
            }
        );

        // console.log('fetchMyinvoisDocs response:', response);
        // localStorage.setItem('myinvois_credentials', JSON.stringify(response.data)); // This seems incorrect here, maybe remove?

        return response.data;

    } catch (error: any) { // Added type annotation for better error handling
        console.error(`Error fetching MyinvoisDocs from ${endpoint}:`, error.response?.data || error.message);
        // Rethrow or handle the error appropriately
        const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch document types.';
        throw new Error(errorMessage);
    }
};

// Conceptual: Add to src/utils/api.ts
// import { api } from './apiConfig'; // Or your actual Axios instance

export const fetchRecentMyinvoisDocumentsFromApi = async (
    bearerToken: string, // <-- Add this parameter

    pageNo: number,
    pageSize: number,
    submissionDateFrom: string,
    submissionDateTo: string
): Promise<RecentDocumentsApiResponse> => {
    // IMPORTANT: The MyInvois API is external.
    // If your `api` instance is configured for your backend,
    // you might need to use a direct Axios call or have your backend proxy this.
    // For this example, let's assume a direct call or a correctly configured base URL.

    // if (!bearerToken) throw new Error('No MyInvois bearer token found');


    // const token = localStorage.getItem('token'); // Get the stored token
    // if (!token) throw new Error('No authentication token found');


    // const response = await axios.get(`https://preprod-api.myinvois.hasil.gov.my/api/v1.0/documents/recent`, {
    //     headers: {
    //         Authorization: `Bearer ${bearerToken}`,
    //         'Content-Type': 'application/json'
    //     }, params: {
    //         pageNo,
    //         pageSize,
    //         submissionDateFrom,
    //         submissionDateTo,
    //     },
    //     // Ensure your Axios instance or this call includes the necessary
    //     // Authorization: Bearer <token> header for the MyInvois API.
    //     // This might be handled by an interceptor if using a shared `api` instance.
    // });

    const token = localStorage.getItem('token'); // Get the stored token
    if (!token) {
        // It's often better to throw an error here or handle it consistently
        console.error('Error: No authentication token found for fetchMyinvoisDocs');
        throw new Error('Authentication required.');
    }

    // Construct the endpoint dynamically
    let endpoint = '/myinvois/documents/recent';


    console.log(`Fetching Myinvois docs from endpoint: ${endpoint}`); // Log the final endpoint being used

    try {
        const response = await api.get(
            endpoint, // Use the dynamically constructed endpoint
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Send the token in the Authorization header
                },
                // No need for params if the code is part of the URL path
            }
        );

        // console.log('fetchMyinvoisDocs response:', response);
        // localStorage.setItem('myinvois_credentials', JSON.stringify(response.data)); // This seems incorrect here, maybe remove?

        return response.data;

    } catch (error: any) { // Added type annotation for better error handling
        console.error(`Error fetching MyinvoisDocs from ${endpoint}:`, error.response?.data || error.message);
        // Rethrow or handle the error appropriately
        const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch document types.';
        throw new Error(errorMessage);
    }
};


export const fetchMyinvoisMsicCodes = async () => {

    const token = localStorage.getItem('token'); // Get the stored token

    try {
        const response = await api.get(
            `/myinvois/msic-codes`,
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Send the token in the Authorization header
                },
            }
        );

        // console.log('fetchMyinvoisCredentials:', response);

        localStorage.setItem('myinvois_msic_codes', JSON.stringify(response.data));

        return response.data;
    } catch (error) {
        console.error('Error fetchMyinvoisMsicCodes :', error);
        throw error;
    }
};
// ... other imports and api instance ...

/**
 * Validates a Buyer's TIN via the backend MyInvois validation endpoint.
 * @param tin - The Taxpayer Identification Number to validate.
 * @param idType - The type of identification (NRIC, PASSPORT, BRN, ARMY).
 * @param idValue - The identification number corresponding to the idType.
 * @returns The validation result from the backend.
 */
export const validateMyinvoisTin = async (
    tin: string,
    idType: string,
    idValue: string
): Promise<any> => { // Use 'any' or a more specific type for the expected response
    const token = localStorage.getItem('token');
    if (!token) {
        console.error('Authentication token not found for validateMyinvoisTin.');
        throw new Error('Authentication required.');
    }

    // Construct the URL with query parameters
    const url = `/myinvois/validate-tin/${encodeURIComponent(tin)}`;
    const params = {
        idType: idType,
        idValue: idValue,
    };

    try {
        // console.log(`Attempting GET ${url} with params:`, params);
        const response = await api.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            params: params, // Pass query parameters here
        });
        // console.log(`TIN validation successful for ${tin}:`, response.data);
        return response.data; // Return the validation data from the backend
    } catch (error: any) {
        const errorDetails = error.response?.data || error.message || error;
        console.error(`Error validating TIN ${tin}:`, errorDetails);
        // Re-throw the error so the calling component can handle it
        throw error;
    }
};


export const fetchInvoiceItems = async (invoiceId: number): Promise<InvoiceItem[]> => {
    const token = localStorage.getItem('token');
    if (!token) {
        console.error('Authentication token not found for fetchInvoiceItems.');
        throw new Error('Authentication required.');
    }

    const url = `/invoices/${invoiceId}/items`; // Adjust endpoint if different

    try {
        // console.log(`Fetching items for invoice ${invoiceId} from ${url}`);
        const response = await api.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // Add validation if necessary
        if (!Array.isArray(response.data)) {
            console.error("Invalid data format received for invoice items:", response.data);
            throw new Error("Received invalid data format for invoice items.");
        }

        console.log(`Fetched items for invoice ${invoiceId}:`, response.data);
        return response.data as InvoiceItem[]; // Cast to your updated type

    } catch (error: any) {
        const errorDetails = error.response?.data || error.message || error;
        console.error(`Error fetching items for invoice ${invoiceId}:`, errorDetails);
        throw error;
    }
};

// Placeholder for adding a new invoice item
export const addInvoiceItem = async (invoiceId: number, itemData: Partial<InvoiceItem>): Promise<InvoiceItem> => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Authentication required.');

    const url = `/invoices/${invoiceId}/items`; // Your POST endpoint
    console.log(`Attempting POST ${url}`, itemData); // Log the actual attempt

    // --- Use the actual API call ---
    try {
        // Uncomment this line and ensure Content-Type is set
        const response = await api.post(url, itemData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json', // Important for POST/PATCH/PUT
            }
        });
        console.log('Add item successful:', response.data);
        // Assuming the backend returns the newly created item with its ID
        return response.data;
    } catch (error: any) {
        // Log the error and re-throw it
        const errorDetails = error.response?.data || error.message || error;
        console.error(`Error adding item to invoice ${invoiceId}:`, errorDetails);
        throw error; // Re-throw so the calling function (handleSaveItem) knows about the failure
    }
    // --- Remove or comment out the placeholder code ---
    // await new Promise(resolve => setTimeout(resolve, 500));
    // return { ...itemData, id: Date.now() } as InvoiceItem;
    // --- End Placeholder Removal ---
};

// Placeholder for updating an existing invoice item
export const updateInvoiceItem = async (itemId: number, itemData: Partial<InvoiceItem>): Promise<InvoiceItem> => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Authentication required.');

    const url = `/invoice-items/${itemId}`; // Your PUT/PATCH endpoint
    console.log(`Attempting PATCH ${url}`, itemData); // Log the attempt

    // --- Use the actual API call ---
    try {
        // Uncomment this line (assuming you use PATCH, change to api.put if needed)
        const response = await api.patch(url, itemData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json', // Ensure content type is set
            }
        });
        console.log('Update successful:', response.data);
        return response.data; // Return the actual response from the backend
    } catch (error: any) {
        // Log the error and re-throw it
        const errorDetails = error.response?.data || error.message || error;
        console.error(`Error updating item ${itemId}:`, errorDetails);
        throw error; // Re-throw so the calling function knows about the failure
    }
    // --- Remove or comment out the placeholder code ---
    // await new Promise(resolve => setTimeout(resolve, 500));
    // return { ...itemData, id: itemId } as InvoiceItem;
    // --- End Placeholder Removal ---
};


// --- Caching for Lookups ---
let cachedClassificationCodes: ClassificationCode[] | null = null;
let cachedUnitTypes: UnitType[] | null = null;
let cachedTaxTypes: TaxType[] | null = null;
// --- End Caching ---

// ... existing API functions ...

// --- Fetch Classification Codes ---
export const fetchClassificationCodes = async (): Promise<ClassificationCode[]> => {
    if (cachedClassificationCodes) {
        console.log('Returning cached classification codes');
        return cachedClassificationCodes;
    }
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Authentication required.');

    try {
        const response = await api.get('/v1/classification-codes', { // Use your API endpoint
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!Array.isArray(response.data)) {
            throw new Error("Invalid data format for classification codes.");
        }
        cachedClassificationCodes = response.data as ClassificationCode[];
        // console.log('Fetched and cached classification codes');
        return cachedClassificationCodes;
    } catch (error: any) {
        console.error("Failed to fetch classification codes:", error.response?.data || error.message);
        throw error;
    }
};

// --- Fetch Unit Types ---
export const fetchUnitTypes = async (): Promise<UnitType[]> => {
    if (cachedUnitTypes) {
        console.log('Returning cached unit types');
        return cachedUnitTypes;
    }
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Authentication required.');

    try {
        const response = await api.get('/v1/unit-types', { // Use your API endpoint
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!Array.isArray(response.data)) {
            throw new Error("Invalid data format for unit types.");
        }
        cachedUnitTypes = response.data as UnitType[];
        // console.log('Fetched and cached unit types');
        return cachedUnitTypes;
    } catch (error: any) {
        console.error("Failed to fetch unit types:", error.response?.data || error.message);
        throw error;
    }
};

// --- Fetch Tax Types ---
export const fetchTaxTypes = async (): Promise<TaxType[]> => {
    if (cachedTaxTypes) {
        console.log('Returning cached tax types');
        return cachedTaxTypes;
    }
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Authentication required.');

    try {
        const response = await api.get('/v1/tax-types', { // Use your API endpoint
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!Array.isArray(response.data)) {
            throw new Error("Invalid data format for tax types.");
        }
        cachedTaxTypes = response.data as TaxType[];
        // console.log('Fetched and cached tax types');
        return cachedTaxTypes;
    } catch (error: any) {
        console.error("Failed to fetch tax types:", error.response?.data || error.message);
        throw error;
    }
};

/**
 * Updates a specific field for the application settings (Seller Info).
 * Assumes a PATCH endpoint like /settings. Adjust URL if needed.
 * @param field - The specific field (key) of the appConfig object to update.
 * @param value - The new value for the field.
 * @returns The updated settings data from the API.
 */
export const updateSellerInfo = async (
    field: keyof Seller,
    value: string | number | boolean | null // Allow null for potentially clearing fields
) => {
    const token = localStorage.getItem('token');
    if (!token) {
        console.error('Authentication token not found for updateSellerInfo.');
        throw new Error('Authentication required.');
    }

    const payload = { [field]: value };
    const url = `/sellers/1`; // ${customerId}`;

    try {
        // console.log(`Attempting PATCH ${url} with payload:`, payload);
        // Assuming your backend uses PATCH for partial updates
        const response = await api.patch(url, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        // console.log(`Seller info field ${String(field)} updated successfully:`, response.data);

        // Optionally update local storage settings cache if you use it elsewhere
        // const currentSettings = JSON.parse(localStorage.getItem('settings') || '{}');
        // localStorage.setItem('settings', JSON.stringify({ ...currentSettings, ...response.data }));
        return response.data;
    } catch (error: any) {
        const errorDetails = error.response?.data || error.message || error;
        console.error(`Error updating seller info field ${String(field)}:`, errorDetails);
        throw error;
    }
};